export const MuiLinearProgress = {
  styleOverrides: {
    root: {
      backgroundColor: '#DDE7FF',
    },
    bar: {
      backgroundColor: '#1010EB',
    },
  },
};
